export const DEFAULT_OW_SEARCHES_RANGE = 5;
